import styled from "styled-components";

export const RowOutcome = styled.div<{ theme?: any }>`
  display: flex;
  align-items: center;
  margin: 5px;
`;
